import React from 'react';
import {
  Box,
  Flex,
  Text,
  HStack,
  Stack,
  Badge,
  Icon,
  Card,
  CardHeader,
  CardBody,
  Heading,
  Spinner,
  useColorModeValue,
} from '@chakra-ui/react';
import { MdAdminPanelSettings } from 'react-icons/md';

/**
 * AdminView - Component to display administrative information
 * 
 * @param {Object} props - Component props
 * @param {Object} props.stats - Statistics data
 * @param {Object} props.adminViewData - Additional admin view data
 * @param {boolean} props.isLoading - Loading state
 */
const AdminView = ({ stats, adminViewData, isLoading }) => {
  const cardBg = useColorModeValue('white', 'gray.700');
  
  return (
    <Card bg={cardBg} boxShadow="md">
      <CardHeader pb={0}>
        <Heading size="md">Visão Administrativa</Heading>
      </CardHeader>
      <CardBody>
        <Stack spacing={5} mt={2}>
          <Box>
            <Flex justify="space-between" mb={2}>
              <Text>Administradores</Text>
              <Text fontWeight="bold">{stats.adminsCount.value}</Text>
            </Flex>
            <Box bg="gray.100" p={3} borderRadius="md">
              <HStack>
                <Icon as={MdAdminPanelSettings} color="yellow.500" />
                <Text fontSize="sm">
                  {isLoading ? "Carregando..." : 
                    `${adminViewData?.adminsOnline || 0} administradores online agora`}
                </Text>
              </HStack>
            </Box>
          </Box>

          <Box>
            <Flex justify="space-between" mb={2}>
              <Text>Aprovações Pendentes</Text>
              <HStack>
                <Badge colorScheme="red" variant="solid" borderRadius="full">
                  {isLoading ? "-" : stats.pendingApprovals.value}
                </Badge>
                <Text fontWeight="bold">itens</Text>
              </HStack>
            </Flex>
            <Box bg="gray.100" p={3} borderRadius="md">
              <Stack spacing={2} fontSize="sm">
                {isLoading ? (
                  <Text>Carregando...</Text>
                ) : (
                  <>
                    <HStack justify="space-between">
                      <Text>Novas Categorias</Text>
                      <Badge>{adminViewData?.approvalBreakdown?.categories || 0}</Badge>
                    </HStack>
                    <HStack justify="space-between">
                      <Text>Verificação de Contratados</Text>
                      <Badge>{adminViewData?.approvalBreakdown?.workerVerifications || 0}</Badge>
                    </HStack>
                    <HStack justify="space-between">
                      <Text>Disputas</Text>
                      <Badge>{adminViewData?.approvalBreakdown?.disputes || 0}</Badge>
                    </HStack>
                  </>
                )}
              </Stack>
            </Box>
          </Box>

          <Box>
            <Flex justify="space-between" mb={2}>
              <Text>Status do Sistema</Text>
              <Badge colorScheme="green">Operacional</Badge>
            </Flex>
            <Box bg="gray.100" p={3} borderRadius="md">
              <Stack spacing={2} fontSize="sm">
                {isLoading ? (
                  <Text>Carregando...</Text>
                ) : (
                  <>
                    <HStack justify="space-between">
                      <Text>Uso de CPU</Text>
                      <Text>{adminViewData?.systemStatus?.cpu || 0}%</Text>
                    </HStack>
                    <HStack justify="space-between">
                      <Text>Uso de Memória</Text>
                      <Text>{adminViewData?.systemStatus?.memory || 0}%</Text>
                    </HStack>
                    <HStack justify="space-between">
                      <Text>Tempo de Resposta</Text>
                      <Text>{adminViewData?.systemStatus?.responseTime || 0}ms</Text>
                    </HStack>
                  </>
                )}
              </Stack>
            </Box>
          </Box>
        </Stack>
      </CardBody>
    </Card>
  );
};

export default AdminView;